import { ReactNode } from 'react';

export const FAQ_CATEGORIES = new Map([
  ['all', '전체'],
  ['before-apply', '신청 전'],
  ['review', '검토중'],
  ['declare', '신고완료'],
  ['determine', '환급결정'],
  ['refunded', '환급완료'],
  ['impossible', '환급불가'],
  ['cancel', '신청취소']
]);

export const FAQ_CONTENTS: Record<string, { title: string; content: ReactNode }[]> = {
  'before-apply': [
    {
      title: '환급금을 어떻게 찾았나요?',
      content:
        '비즈넵 환급은 과거 5년간 종합소득세, 양도소득세, 법인세 등의 세금 신고 과정에서 놓쳤던 세액 공제, 세액 감면 항목들을 고도화된 AI 기술로 찾아냅니다. 그리고 비즈넵 환급과 제휴한 세무 전문가가 탐색 결과값을 검토하여 놓치는 부분 없이 환급금을 찾아드리고 있습니다.'
    },
    {
      title: '환급받았다가 세무조사 나올까 걱정돼요',
      content:
        '경정청구는 납세자의 권리로, 국세기본법 상 세무조사 대상이 되지 않습니다. 환급 신청 후, 국세청은 이를 검토하고 환급을 승인하거나 거절합니다. 국세청에서 환급을 결정했다면 이미 검증된 안전한 금액이니, 안심하고 이용해보세요.'
    },
    {
      title: '환급을 진행하면 추징금이 발생하나요?',
      content:
        '환급을 진행해도 추징금은 발생하지 않습니다. 비즈넵 환급은 제휴 세무사의 검토를 통해 안정적으로 신고합니다. 책임환불제를 제공하는 비즈넵 환급은 납부 등 불이익이 발생했을 때 100% 해당 이용료를 환불해드리고 사후 관리를 제공해드리니 안심하고 이용해보세요.'
    },
    {
      title: '이용하려면 세무대리인 배정이 필요한가요?',
      content:
        '세무대리인은 환급금 조회할 때에는 배정되지 않으나, 신청 후에는 경정청구 신고를 위해 일회적으로 배정됩니다. 비즈넵 환급을 통한 세무대리인 배정은 기존 세무대리인과의 수임 계약에 영향을 주지 않으니, 걱정하지 마시고 부담 없이 이용해보세요.'
    },
    {
      title: '비즈넵 환급을 이용하면 요금이 부과되나요?',
      content:
        '환급금 조회는 무료지만, 비즈넵 환급 신청 후에 국세청의 최종 환급이 승인되면 결정 환급액의 30%(부가세 별도)에 해당하는 이용료를 알림톡 또는 문자로 안내드립니다. 환급 결정 전 언제든지 취소 가능하며 취소 시 별도의 이용료가 발생하지 않습니다.'
    },
    {
      title: '비즈넵 환급 서비스, 안전한가요?',
      content: (
        <>
          비즈넵 환급에서는 고객의 개인정보보호를 최우선으로 여기며, 강력한 보안을 유지하고 있습니다. 환급 절차 진행을 위해 꼭 필요한 최소한의 정보만 요청드리고
          있으며, 관련 법령에 따라 약속한 보유 기간이 다 되면 지체 없이 파기하고 있으니 안심하셔도 괜찮습니다.
          <br />
          자세한 내용은{' '}
          <a href="https://help.bznav.com/hc/ko/p/security" className={'text-blue-500'} target="_system">
            비즈넵 환급 보안 가이드
          </a>
          에서 확인하실 수 있습니다.
        </>
      )
    },
    {
      title: '조회된 금액대로 환급되나요?',
      content:
        '비즈넵 환급은 AI로 간편하게 예상 환급액을 조회한 다음, 정확한 환급을 위해 신청 후 제휴 세무 전문가가 추가 검토를 진행합니다. 환급금은 이후 국세청의 검토 후 결정되며, 제휴 세무 전문가와 국세청의 검토 과정에서 환급액이 변동될 수 있습니다.'
    },
    {
      title: '폐업한 경우에도 환급금 신청이 가능한가요?',
      content:
        '비즈넵 환급은 과거 5년간 개인사업자의 종합소득세와 개인의 자산 양도 시 발생한 양도소득세, 법인사업자에 대한 법인세의 경정청구 신고를 통해 환급금을 찾아드리고 있어요. 폐업하신지 5년 이내라면 환급금 조회와 신청이 가능합니다.'
    },
    {
      title: '환급금이 0원으로 조회돼요',
      content: '환급금이 발생하지 않았다면, 이미 공제나 감면을 적용하여 환급금을 모두 받으셨거나 세금 신고를 정확히 하신 경우입니다.'
    },
    {
      title: '여러 개 사업체를 운영 중인데, 특정 사업체만 신청할 수 있나요?',
      content:
        '사업체 종류에 따라 신청 가능 여부가 달라집니다. 개인사업체의 경우, 운영 중인 모든 사업체에 대한 환급 가능 여부를 검토한 다음, 가능한 업체에 대해 환급이 진행되기 때문에 특정 사업체만 따로 신청하는 것은 어렵습니다. 법인사업체의 경우, 환급금 조회 시 사업체별 따로 조회 및 신청이 가능합니다.'
    },
    {
      title: '이용료는 어떤 기준으로 책정되는 건가요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>비즈넵 환급의 이용료는 제휴 세무사 비용으로 최종 결정 환급액의 30%(부가세 별도)로 책정됩니다.</div>
          <div>비즈넵 환급은 경정청구 신고를 통한 환급금을 업계 평균 비용으로 찾아드리고 있습니다.</div>
          <div>
            경정청구 신고는 일반적인 다른 세금 신고와는 다르게 준비해야 할 자료가 많고 계산이 복잡하기 때문에 일반적인 신고와는 세무사 업무 비용이 다르게
            책정된다는 점 참고해주세요.
          </div>
        </div>
      )
    }
  ],
  review: [
    {
      title: '환급 결과는 언제 알 수 있나요?',
      content: (
        <>
          비즈넵 환급 제휴 세무사가 검토 후 경정청구 신고 접수를 완료하면, 신고 접수 이후 2개월 이내에 환급 결과를 확인할 수 있습니다. 환급 절차에 대한 자세한
          사항은{' '}
          <a
            href="https://help.bznav.com/hc/ko/articles/7905908716313-%EB%B9%84%EC%A6%88%EB%84%B5-%ED%99%98%EA%B8%89%EC%9D%98-%ED%99%98%EA%B8%89-%EC%A0%88%EC%B0%A8%EA%B0%80-%EA%B6%81%EA%B8%88%ED%95%B4%EC%9A%94"
            className={'text-blue-500'}
            target="_system"
          >
            고객센터 글
          </a>
          을 참고해주세요.
        </>
      )
    },
    {
      title: '환급이 불가능한 경우에도 이용료가 발생하나요?',
      content:
        '환급이 불가능한 경우에는 이용료가 발생하지 않습니다. 이용료는 제휴 세무사 비용으로 결정 환급액의 30%(부가세 별도)이기 때문에 환급액이 감소하면 제휴 세무사 비용도 감소합니다.'
    },
    {
      title: '이용료는 어떤 기준으로 책정되는 건가요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>비즈넵 환급의 이용료는 제휴 세무사 비용으로 최종 결정 환급액의 30%(부가세 별도)로 책정됩니다.</div>
          <div>비즈넵 환급은 경정청구 신고를 통한 환급금을 업계 평균 비용으로 찾아드리고 있습니다.</div>
          <div>
            경정청구 신고는 일반적인 다른 세금 신고와는 다르게 준비해야 할 자료가 많고 계산이 복잡하기 때문에 일반적인 신고와는 세무사 업무 비용이 다르게
            책정된다는 점 참고해주세요.
          </div>
        </div>
      )
    },
    {
      title: '환급 신청은 했는데 전화가 안 와요',
      content:
        '비즈넵 환급은 모든 진행 과정을 카카오톡 알림톡을 통해 안내드리고 있고, 추가 확인이 필요한 경우에만 제휴 세무 전문가가 전화를 드리고 있습니다. 신청 후에는 카카오톡을 확인해주세요.'
    },
    {
      title: '환급금을 어떻게 찾았나요?',
      content:
        '비즈넵 환급은 과거 5년간 종합소득세, 양도소득세, 법인세 등의 세금 신고 과정에서 놓쳤던 세액 공제, 세액 감면 항목들을 고도화된 AI 기술로 찾아냅니다. 그리고 비즈넵 환급과 제휴한 세무 전문가가 탐색 결과값을 검토하여 놓치는 부분 없이 환급금을 찾아드리고 있습니다.'
    },
    {
      title: '몇 년 치 환급금인가요?',
      content: '비즈넵 환급은 과거 5년(직전년도 기준) 동안의 환급금을 찾아드리고 있습니다.'
    },
    {
      title: '제출할 자료가 있나요?',
      content:
        '비즈넵 환급은 서류 제출 없이 쉽고 간편하게 환급금을 찾아드리는 서비스를 제공합니다. 간혹 국세청에서 검토 중 추가 확인이 필요할 경우에만 서류를 요청드리고 있습니다. 필요한 자료는 제휴 세무 전문가가 안내드릴 예정입니다.'
    },
    {
      title: '조회된 금액대로 환급되나요?',
      content:
        '비즈넵 환급은 AI로 간편하게 예상 환급액을 조회한 다음, 정확한 환급을 위해 신청 후 제휴 세무 전문가가 추가 검토를 진행합니다. 환급금은 이후 국세청의 검토 후 결정되며, 제휴 세무 전문가와 국세청의 검토 과정에서 환급액이 변동될 수 있습니다.'
    },
    {
      title: '미납 혹은 체납 중인 세금이 있는 경우에도 환급이 되나요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>미납 혹은 체납 중인 세금이 있다면, 국세청에서 환급이 결정된 후 환급금은 세금 납부로 충당됩니다.</div>
          <div>국세청에서 환급이 결정되었다면, 세금으로 대신 충당되더라도 이용료는 결제해주셔야 합니다.</div>
        </div>
      )
    }
  ],
  declare: [
    {
      title: '환급금을 더 빨리 받고 싶어요',
      content:
        '비즈넵 환급에서 경정청구 신고를 완료한 후 국세청 검토까지 완료되어야 최종 환급이 결정됩니다. 국세청 검토는 신고일로부터 평균적으로 2개월 정도 소요됩니다. 편하게 확인하실 수 있도록 국세청 환급 결과 확인이 가능할 때 카카오톡 알림톡으로 안내드리겠습니다.'
    },
    {
      title: '환급 신청한 지 2개월이 지났어요',
      content: '국세청에서 추가 확인이 필요한 경우 2개월 이상 소요될 수 있습니다. 세부 진행사항이 궁금하시다면 고객센터로 문의해주세요.'
    },
    {
      title: '세금을 추가 납부하게 될 수도 있나요?',
      content: '비즈넵 환급에서는 고객님께서 추가 납부하시는 일이 없도록 제휴 세무사의 검토를 통해 최대한 보수적으로 신고하고 있으니 안심하셔도 됩니다.'
    },
    {
      title: '환급받을 계좌를 변경하고 싶어요',
      content: '신고가 완료되면 국세청에서 검토가 진행되기 때문에 계좌 변경이 어렵습니다. 국세 환급은 본인 명의의 계좌로만 지급이 가능한 점 참고해주세요.'
    },
    {
      title: '환급금을 어떻게 찾았나요?',
      content:
        '비즈넵 환급은 과거 5년간 종합소득세, 양도소득세, 법인세 등의 세금 신고 과정에서 놓쳤던 세액 공제, 세액 감면 항목들을 고도화된 AI 기술로 찾아냅니다. 그리고 비즈넵 환급과 제휴한 세무 전문가가 탐색 결과값을 검토하여 놓치는 부분 없이 환급금을 찾아드리고 있습니다.'
    },
    {
      title: '농어촌특별세 고지서를 받았어요',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>그렇다면 특정 조세 혜택이 잘 적용되어 환급 신청이 완료된 경우입니다.</div>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>개인사업자의 경우,</strong> 비즈넵 환급에서는 개인사업자의 농어촌특별세를 신고할 때 환급금에서 충당되도록 충당서를 함께 발송하기 때문에
              따로 납부하지 않으셔도 됩니다. 만약 납부가 필요한 경우라면 따로 카카오톡 알림톡으로 안내드리겠습니다.
            </li>
            <li>
              <strong>법인사업자의 경우,</strong> 농어촌 특별세는 특정 조세 혜택을 받은 환급 건에 적용되는 세금으로 혜택 금액의 20%를 납부해야 합니다. 비즈넵
              환급에서는 법인사업자의 농어촌특별세를 반영해 신고하고 있으며 곧 농어촌 특별세로 고지된 금액보다 더 큰 금액으로 환급이 이루어지니 고지서를 확인해
              납부해주시면 됩니다.
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '조회된 금액대로 환급되나요?',
      content:
        '비즈넵 환급은 AI로 간편하게 예상 환급액을 조회한 다음, 정확한 환급을 위해 신청 후 제휴 세무 전문가가 추가 검토를 진행합니다. 환급금은 이후 국세청의 검토 후 결정되며, 제휴 세무 전문가와 국세청의 검토 과정에서 환급액이 변동될 수 있습니다.'
    },
    {
      title: '환급 결과는 언제, 어떻게 확인할 수 있나요?',
      content:
        '국세청 검토는 신고일로부터 평균 2개월 정도 소요됩니다. 신고 완료일로부터 5주 후에 보내드리는 카카오톡 알림톡과 비즈넵 환급 서비스에서 환급 결과를 확인하실 수 있어요.'
    }
  ],
  determine: [
    {
      title: '농어촌특별세 고지서를 받았어요',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>그렇다면 특정 조세 혜택이 잘 적용되어 환급 신청이 완료된 경우입니다.</div>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>개인사업자의 경우,</strong> 비즈넵 환급에서는 개인사업자의 농어촌특별세를 신고할 때 환급금에서 충당되도록 충당서를 함께 발송하기 때문에
              따로 납부하지 않으셔도 됩니다. 만약 납부가 필요한 경우라면 따로 카카오톡 알림톡으로 안내드리겠습니다.
            </li>
            <li>
              <strong>법인사업자의 경우,</strong> 농어촌 특별세는 특정 조세 혜택을 받은 환급 건에 적용되는 세금으로 혜택 금액의 20%를 납부해야 합니다. 비즈넵
              환급에서는 법인사업자의 농어촌특별세를 반영해 신고하고 있으며 곧 농어촌 특별세로 고지된 금액보다 더 큰 금액으로 환급이 이루어지니 고지서를 확인해
              납부해주시면 됩니다.
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '결제는 어떻게 하나요?',
      content: '환급 과정이 완료되면 카카오톡 알림톡이나 문자 메시지로 결제 안내를 발송해드립니다. 이용료와 결제 방법을 확인하신 다음 결제를 진행해주세요.'
    },
    {
      title: '환급액이 처음 조회했을 때와 달라요',
      content: '환급액은 제휴 세무사와 국세청 검토 후에 결정되며, 검토 과정에서 금액이 일부 변동될 수 있습니다. 이용료는 최종 결정 환급액 기준으로 책정됩니다.'
    },
    {
      title: '환급금 입금은 언제 되나요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>
            환급금 입금은 환급 결정 후 최대 14일까지 소요될 수 있습니다. 환급금은 관할세무서명으로 입금되며, 환급 완료가 된 것으로 확인되면 카카오톡 알림톡으로
            안내드릴 예정입니다.
          </div>
          <div>
            국세청의 검토 부서와 지급 부서가 다르기 때문에, 환급 지급일에 차이가 생길 수 있습니다. 비즈넵 환급에서는 검토 부서의 확인 기준으로 안내드리는 점
            참고해주세요.
          </div>
        </div>
      )
    },
    {
      title: '이용료는 어떤 기준으로 책정되는 건가요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>비즈넵 환급의 이용료는 제휴 세무사 비용으로 최종 결정 환급액의 30%(부가세 별도)로 책정됩니다.</div>
          <div>비즈넵 환급은 경정청구 신고를 통한 환급금을 업계 평균 비용으로 찾아드리고 있습니다.</div>
          <div>
            경정청구 신고는 일반적인 다른 세금 신고와는 다르게 준비해야 할 자료가 많고 계산이 복잡하기 때문에 일반적인 신고와는 세무사 업무 비용이 다르게
            책정된다는 점 참고해주세요.
          </div>
        </div>
      )
    },
    {
      title: '환급금 통지서를 받았어요',
      content:
        '비즈넵 환급은 신청 시 입력하신 계좌번호를 기재해 신고를 접수하고 있습니다. 다만, 국세청 담당 공무원의 검토 과정 중 계좌 오류가 발생하거나, 납세자의 기타 상황에 따라서 현금으로 수령하는 방법인 통지서가 발송될 수 있습니다. 환급금은 통지서에 기재되어 있는 방법으로 받을 수 있습니다.'
    },
    {
      title: '환급금은 어떤 이름으로 들어오나요?',
      content:
        '환급금은 국세청 또는 관할세무서에서 입금됩니다. 입금자명은 보통 ‘관할세무서명, ‘국고환급’, ‘센타입금’ 등으로 입금됩니다. 비즈넵 환급 이름으로 입금되지 않는 점 참고해주세요.'
    },
    {
      title: '미납 혹은 체납 중인 세금이 있는 경우에도 환급이 되나요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>미납 혹은 체납 중인 세금이 있다면, 국세청에서 환급이 결정된 후 환급금은 세금 납부로 충당됩니다.</div>
          <div>국세청에서 환급이 결정되었다면, 세금으로 대신 충당되더라도 이용료는 결제해주셔야 합니다.</div>
        </div>
      )
    }
  ],
  refunded: [
    {
      title: '신청했던 환급금과 실제 입금된 금액이 달라요',
      content:
        '환급금은 연도별로 분할되어 입금됩니다. 연도별 환급금은 각각 다른 날짜로 입금될 수 있고, 입금된 총 환급액은 연도별로 이자가 더해져 결정 환급액보다 클 수 있습니다. 자세한 사항이 궁금하시다면 고객센터로 문의해주세요.'
    },
    {
      title: '이용료가 30%가 넘는 것 같아요',
      content: '이용료는 제휴 세무사 비용으로 결정 환급액의 30%(부가세 별도)입니다. 결제 금액은 부가세가 포함된 금액으로 안내드립니다.'
    },
    {
      title: '이용료를 먼저 결제해야 입금이 되나요?',
      content:
        '비즈넵 환급에서는 환급이 완료된 후 결제 안내를 드리기 때문에, 국세청에서 환급 완료 처리가 되기 전에는 결제 안내를 드리고 있지 않습니다. 환급금 입금이 계속 확인되지 않으신다면 고객센터로 문의해주세요.'
    },
    {
      title: '환급금이 분할 입금되나요?',
      content: '환급금은 연도별로 분할되어 입금됩니다. 연도별 환급금은 각각 다른 날짜로 입금될 수 있습니다.'
    },
    {
      title: '결제는 어떻게 하나요?',
      content: '환급 과정이 완료되면 카카오톡 알림톡이나 문자 메시지로 결제 안내를 발송해드립니다. 이용료와 결제 방법을 확인하신 다음 결제를 진행해주세요.'
    },
    {
      title: '개인사업자 현금영수증은 어떻게 발급하나요?',
      content:
        '계좌 입금이 완료되면 자진번호로 현금영수증을 발급한 후 카카오톡 알림톡으로 발급 정보를 전달해드립니다. 발급 정보로 홈택스에서 현금영수증을 등록해주세요.'
    },
    {
      title: '이용료 할부 결제가 가능한가요?',
      content:
        '카드 결제를 이용하면 결제 금액이 200,000원 이상인 경우 할부 결제가 가능합니다. 할부 결제가 필요하시다면 카카오톡 알림톡이나 문자 메시지로 받으신 결제 링크에서 [카드사 앱으로 결제하기]를 눌러 결제를 진행해주세요.'
    },
    {
      title: '환급이 완료되었다는데, 환급금 입금이 되지 않았어요',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>환급금이 확인되지 않는다면 아래 경우를 확인해주세요.</div>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>환급 완료 안내일 전에 이미 환급된 경우 :</strong> 국세청의 검토 부서와 지급부서가 다르기 때문에, 환급 지급일에 차이가 생길 수 있습니다.
            </li>
            <li>
              <strong>환급금이 체납된 세금 납부로 충당된 경우</strong>
            </li>
            <li>
              <strong>직접 수령하는 방법인 환급금 통지서가 발송된 경우</strong>
            </li>
          </ul>
          <div>정확한 환급 결과가 궁금하시다면 고객센터로 문의해주세요.</div>
        </div>
      )
    },
    {
      title: '환급금 통지서를 받았어요',
      content:
        '비즈넵 환급은 신청 시 입력하신 계좌번호를 기재해 신고를 접수하고 있습니다. 다만, 국세청 담당 공무원의 검토 과정 중 계좌 오류가 발생하거나, 납세자의 기타 상황에 따라서 현금으로 수령하는 방법인 통지서가 발송될 수 있습니다. 환급금은 통지서에 기재되어 있는 방법으로 받을 수 있습니다.'
    },
    {
      title: '환급금은 어떤 이름으로 들어오나요?',
      content:
        '환급금은 국세청 또는 관할세무서에서 입금됩니다. 입금자명은 보통 ‘관할세무서명, ‘국고환급’, ‘센타입금’ 등으로 입금됩니다. 비즈넵 환급 이름으로 입금되지 않는 점 참고해주세요.'
    },
    {
      title: '신고서를 받고 싶어요',
      content: '신고서는 결제가 완료된 경우에 메일로 받으실 수 있습니다. 결제 후에 고객센터로 문의해주시면 신고서를 발송해드리겠습니다.'
    }
  ],
  impossible: [
    {
      title: '환급이 불가능한 이유는 뭔가요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>
            비즈넵 환급에서는 AI가 모든 적용 가능한 감면 내역을 적용해 환급금을 계산한 이후 제휴 세무 전문가가 추가로 검토하여 실제로 감면 적용이 가능한지
            확인하고 있습니다. 이때 실제로 감면 적용이 어렵다고 확인된 경우, 환급이 어렵습니다.
          </div>
          <div>환급이 어려운 자세한 이유를 확인하고 싶으시다면 고객센터로 문의해주세요.</div>
        </div>
      )
    },
    {
      title: '환급이 불가능할 때에도 이용료가 발생하나요?',
      content: '환급이 불가능한 경우 제휴 세무사 비용은 발생하지 않으므로 걱정하지 않으셔도 됩니다.'
    }
  ],
  cancel: [
    {
      title: '취소는 언제 완료되나요?',
      content: '취소를 접수하면 영업일 기준 3일 안에 완료됩니다. 완료된 후에는 카카오톡 알림톡으로 안내드립니다. '
    },
    {
      title: '취소해도 이용료가 발생하나요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>비즈넵 환급은 환급 완료 후 결제하는 후불제 시스템으로, 완료 전에 취소하면 별도의 이용료가 발생하지 않습니다.</div>
          <div>
            취소 접수와 함께 검토는 중단되기 때문에 환급 진행이 되지 않으며 이용료도 발생하지 않습니다. 단, 국세청에서 환급 결정이 완료되었다면 취소 접수가
            어렵습니다.
          </div>
        </div>
      )
    },
    {
      title: '취소한 후에도 다시 신청할 수 있나요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>비즈넵 환급에서는 취소 완료 후에도 언제든지 다시 신청할 수 있습니다.</div>
          <div>
            취소 접수 후 취소 완료가 되기 전에 취소를 철회하고 이어서 환급을 진행하길 원하신다면, [다시 환급 진행하기]를 눌러 재진행하시거나 고객센터로
            문의해주세요.
          </div>
        </div>
      )
    },
    {
      title: '취소 완료되면 알림이 오나요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>취소가 완료되면 카카오톡 알림톡으로 알려드립니다.</div>
          <div>
            취소 완료가 되기 전에 취소를 철회하고 이어서 환급을 진행하길 원하신다면, [다시 환급 진행하기]를 눌러 재진행하시거나 고객센터로 문의해주세요.
          </div>
        </div>
      )
    },
    {
      title: '신청 취소가 안 되는 경우도 있나요?',
      content: (
        <div className={'flex flex-col gap-[8px]'}>
          <div>국세청에서 환급 결정이 완료되었다면 신청 취소가 불가능합니다.</div>
          <div>
            국세청에서 환급 검토가 완료되어 환급이 결정되었기 때문에, 경정청구 신고 취소가 어려워 비즈넵 환급에서도 신청 취소가 어렵습니다. 따라서 환급이
            완료되면 환급금에 대한 이용료를 결제해주셔야 합니다.
          </div>
        </div>
      )
    }
  ]
};
